import { useEffect } from "react";
import Header from "@/components/Header";
import LegalBanner from "@/components/LegalBanner";
import Footer from "@/components/Footer";
import LegalDoc from "@/components/LegalDoc";
import { Seo } from "@/lib/seo";
import { TERMS } from "@/pages/legalTerms";

export default function Terms() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white text-stone-900 font-sans antialiased" data-testid="terms-page">
      <Seo
        title="Terms of Service | DriveClear"
        description="The Terms of Service governing your use of the DriveClear application, website, and related services."
        path="/terms"
      />
      <LegalBanner />
      <Header />
      <main className="py-14 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight mb-2">Terms of Service</h1>
          <p className="text-sm text-stone-500 mb-2">{TERMS.updated}</p>
          <p className="text-sm text-stone-600 leading-relaxed mb-4">{TERMS.intro}</p>
          <LegalDoc blocks={TERMS.blocks} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
